// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pcoded-header.header-labelflow {
  position: relative;
  display: block;
  width: 100%;
  min-height: 0;
  padding: 0;
}

.lf-header__bar {
  display: flex;
  align-items: center;
  gap: clamp(0.35rem, 1.5vw, 0.75rem);
  min-height: 56px;
  padding-inline: clamp(0.6rem, 2.5vw, 1.5rem);
  padding-block: 0.35rem;
  padding-top: max(0.35rem, env(safe-area-inset-top));
}

.lf-nav-toggle {
  flex: 0 0 auto;
}

.lf-brand {
  display: inline-flex;
  align-items: center;
  flex: 0 0 auto;
  padding: 0 0.15rem;
  border: 0;
  background: transparent;
  cursor: pointer;
}

.lf-brand .lf-logo {
  --lf-logo-size: clamp(22px, 3.6vw, 26px);
}

.lf-brand .lf-logo__mark {
  width: var(--lf-logo-size);
  height: var(--lf-logo-size);
}

.lf-header__actions {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  flex: 0 0 auto;
  margin-left: auto;
}

.lf-nav {
  flex: 1 1 auto;
  min-width: 0;
}

.lf-nav__list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.15rem;
  margin: 0;
  padding: 0;
  list-style: none;
}

.lf-nav__group {
  position: relative;
}

.lf-nav__trigger {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.4rem 0.7rem;
  border: 0;
  border-radius: var(--radius-sm);
  background: transparent;
  color: var(--header-foreground);
  opacity: 0.85;
  font: inherit;
  font-size: 0.9rem;
  font-weight: 500;
  line-height: 1.4;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color var(--transition-fast), color var(--transition-fast), opacity var(--transition-fast);
}
.lf-nav__trigger:hover, .lf-nav__trigger.is-open {
  background: var(--accent);
  color: var(--accent-foreground);
  opacity: 1;
}
.lf-nav__trigger.is-current {
  color: var(--primary);
  opacity: 1;
}

.lf-nav__caret {
  font-size: 0.6rem;
  transition: transform var(--transition-fast);
}
.lf-nav__trigger.is-open .lf-nav__caret {
  transform: rotate(180deg);
}

.lf-nav__panel {
  position: absolute;
  top: calc(100% + 0.35rem);
  left: 0;
  z-index: 1040;
  min-width: 230px;
  max-width: min(320px, 100vw - 1.5rem);
  padding: 0.3rem;
  background: var(--popover);
  color: var(--popover-foreground);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow-lg);
}
.lf-nav__panel[hidden] {
  display: none;
}

.lf-nav__panel-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.lf-nav__item {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  width: 100%;
  padding: 0.5rem 0.65rem;
  border: 0;
  border-radius: var(--radius-sm);
  background: transparent;
  color: var(--popover-foreground);
  font: inherit;
  font-size: 0.875rem;
  text-align: left;
  cursor: pointer;
  transition: background-color var(--transition-fast), color var(--transition-fast);
}
.lf-nav__item:hover {
  background: var(--accent);
  color: var(--accent-foreground);
}
.lf-nav__item.is-current {
  color: var(--primary);
  font-weight: 600;
}

.lf-nav__item-icon {
  flex: 0 0 auto;
  width: 1rem;
  text-align: center;
  font-size: 0.8rem;
  opacity: 0.75;
}

.lf-user {
  position: relative;
}

.lf-user__panel {
  left: auto;
  right: 0;
  min-width: 200px;
}

.lf-user__name {
  margin: 0 0 0.25rem;
  padding: 0.5rem 0.65rem;
  border-bottom: 1px solid var(--border);
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--foreground);
  overflow-wrap: break-word;
}

.lf-drawer {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 1040;
  max-height: 70vh;
  max-height: 70dvh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 0.4rem clamp(0.6rem, 2.5vw, 1.5rem) max(0.6rem, env(safe-area-inset-bottom));
  background: var(--popover);
  color: var(--popover-foreground);
  border-top: 1px solid var(--border);
  border-bottom: 1px solid var(--border);
  box-shadow: var(--shadow-lg);
}
.lf-drawer[hidden] {
  display: none;
}

.lf-drawer__section + .lf-drawer__section {
  margin-top: 0.35rem;
  padding-top: 0.35rem;
  border-top: 1px solid var(--border);
}

.lf-drawer__title {
  margin: 0;
  padding: 0.5rem 0.65rem 0.2rem;
  font-size: 0.68rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--muted-foreground);
}

.lf-drawer .lf-nav__item {
  padding-block: 0.7rem;
  font-size: 0.95rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/Common/header/styles/header.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mCAAmC;EACnC,gBAAgB;EAChB,4CAA4C;EAC5C,sBAAsB;EACtB,mDAAmD;AACrD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,SAAS;EACT,+BAA+B;EAC/B,uBAAuB;EACvB,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iHAAiH;AACnH;AACA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,4CAA4C;AAC9C;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,qCAAqC;EACrC,eAAe;EACf,0BAA0B;EAC1B,gCAAgC;EAChC,+BAA+B;EAC/B,4BAA4B;EAC5B,4BAA4B;AAC9B;AACA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,SAAS;EACT,+BAA+B;EAC/B,uBAAuB;EACvB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iFAAiF;AACnF;AACA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;EACjC,qFAAqF;EACrF,0BAA0B;EAC1B,gCAAgC;EAChC,mCAAmC;EACnC,sCAAsC;EACtC,4BAA4B;AAC9B;AACA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB","sourcesContent":[".pcoded-header.header-labelflow {\n  position: relative;\n  display: block;\n  width: 100%;\n  min-height: 0;\n  padding: 0;\n}\n\n.lf-header__bar {\n  display: flex;\n  align-items: center;\n  gap: clamp(0.35rem, 1.5vw, 0.75rem);\n  min-height: 56px;\n  padding-inline: clamp(0.6rem, 2.5vw, 1.5rem);\n  padding-block: 0.35rem;\n  padding-top: max(0.35rem, env(safe-area-inset-top));\n}\n\n.lf-nav-toggle {\n  flex: 0 0 auto;\n}\n\n.lf-brand {\n  display: inline-flex;\n  align-items: center;\n  flex: 0 0 auto;\n  padding: 0 0.15rem;\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n}\n\n.lf-brand .lf-logo {\n  --lf-logo-size: clamp(22px, 3.6vw, 26px);\n}\n\n.lf-brand .lf-logo__mark {\n  width: var(--lf-logo-size);\n  height: var(--lf-logo-size);\n}\n\n.lf-header__actions {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  flex: 0 0 auto;\n  margin-left: auto;\n}\n\n.lf-nav {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.lf-nav__list {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.15rem;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.lf-nav__group {\n  position: relative;\n}\n\n.lf-nav__trigger {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  padding: 0.4rem 0.7rem;\n  border: 0;\n  border-radius: var(--radius-sm);\n  background: transparent;\n  color: var(--header-foreground);\n  opacity: 0.85;\n  font: inherit;\n  font-size: 0.9rem;\n  font-weight: 500;\n  line-height: 1.4;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: background-color var(--transition-fast), color var(--transition-fast), opacity var(--transition-fast);\n}\n.lf-nav__trigger:hover, .lf-nav__trigger.is-open {\n  background: var(--accent);\n  color: var(--accent-foreground);\n  opacity: 1;\n}\n.lf-nav__trigger.is-current {\n  color: var(--primary);\n  opacity: 1;\n}\n\n.lf-nav__caret {\n  font-size: 0.6rem;\n  transition: transform var(--transition-fast);\n}\n.lf-nav__trigger.is-open .lf-nav__caret {\n  transform: rotate(180deg);\n}\n\n.lf-nav__panel {\n  position: absolute;\n  top: calc(100% + 0.35rem);\n  left: 0;\n  z-index: 1040;\n  min-width: 230px;\n  max-width: min(320px, 100vw - 1.5rem);\n  padding: 0.3rem;\n  background: var(--popover);\n  color: var(--popover-foreground);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  box-shadow: var(--shadow-lg);\n}\n.lf-nav__panel[hidden] {\n  display: none;\n}\n\n.lf-nav__panel-list {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.lf-nav__item {\n  display: flex;\n  align-items: center;\n  gap: 0.55rem;\n  width: 100%;\n  padding: 0.5rem 0.65rem;\n  border: 0;\n  border-radius: var(--radius-sm);\n  background: transparent;\n  color: var(--popover-foreground);\n  font: inherit;\n  font-size: 0.875rem;\n  text-align: left;\n  cursor: pointer;\n  transition: background-color var(--transition-fast), color var(--transition-fast);\n}\n.lf-nav__item:hover {\n  background: var(--accent);\n  color: var(--accent-foreground);\n}\n.lf-nav__item.is-current {\n  color: var(--primary);\n  font-weight: 600;\n}\n\n.lf-nav__item-icon {\n  flex: 0 0 auto;\n  width: 1rem;\n  text-align: center;\n  font-size: 0.8rem;\n  opacity: 0.75;\n}\n\n.lf-user {\n  position: relative;\n}\n\n.lf-user__panel {\n  left: auto;\n  right: 0;\n  min-width: 200px;\n}\n\n.lf-user__name {\n  margin: 0 0 0.25rem;\n  padding: 0.5rem 0.65rem;\n  border-bottom: 1px solid var(--border);\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--foreground);\n  overflow-wrap: break-word;\n}\n\n.lf-drawer {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  z-index: 1040;\n  max-height: 70vh;\n  max-height: 70dvh;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  padding: 0.4rem clamp(0.6rem, 2.5vw, 1.5rem) max(0.6rem, env(safe-area-inset-bottom));\n  background: var(--popover);\n  color: var(--popover-foreground);\n  border-top: 1px solid var(--border);\n  border-bottom: 1px solid var(--border);\n  box-shadow: var(--shadow-lg);\n}\n.lf-drawer[hidden] {\n  display: none;\n}\n\n.lf-drawer__section + .lf-drawer__section {\n  margin-top: 0.35rem;\n  padding-top: 0.35rem;\n  border-top: 1px solid var(--border);\n}\n\n.lf-drawer__title {\n  margin: 0;\n  padding: 0.5rem 0.65rem 0.2rem;\n  font-size: 0.68rem;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--muted-foreground);\n}\n\n.lf-drawer .lf-nav__item {\n  padding-block: 0.7rem;\n  font-size: 0.95rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
